import React, { useState, useEffect } from 'react'
import FetchApi from '../customhooks/functionFetchApi';
import Spinner from 'react-bootstrap/Spinner';
import Tablelistallprovebyuser from './components/componentallistallpprovebyuser/tablelistallprovebyuser';
import { FaList, FaTasks, FaArchive, FaCheck, FaSearch, FaFileAlt } from "react-icons/fa";
import PopupSearch from './prepass/prepasscomponent/popupsearch';

const Journalstatusapprove = () => {
    const FetchApis = new FetchApi();
    const [loading, setLoading] = useState(false);
    const [datajournal, setDatajournal] = useState([]);
    const [journalList, setJournalList] = useState([]);

    useEffect(() => {
        loadingdata();
    }, [])

    const loadingdata = () => {
        setLoading(true)
        setTimeout(() => {
            FetchApis.FethcGet('/journal/journalbyStatusall').then((resultdata) => {
                if (resultdata) {
                    setDatajournal(resultdata.data.data);
                    setJournalList(resultdata.data.data);
                }
                setLoading(false);
            })
        }, 1000);
    }

    function heandleSearch(e) {
        const { value } = e.target;
        const filteredData = datajournal.filter((item) =>
            Object.values(item).join('').toLowerCase().includes(value.toLowerCase())
        )
        setJournalList(filteredData)
    }

    // แปลง dateconfirm (yyyy-mm-dd h:mm:ss หรือ ISO) เป็นตัวเลขเพื่อเรียง, ถ้าไม่มีค่าให้อยู่ท้ายสุด
    const toTime = (value) => {
        const m = String(value || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[\sT,]+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?/);
        if (!m) return 0;
        const [, y, mo, d, h = 0, mi = 0, s = 0] = m;
        return new Date(+y, +mo - 1, +d, +h, +mi, +s).getTime();
    }

    function filterSuccesfull() {
        setLoading(true)
        setJournalList(
            datajournal
                .filter((item) => item.flowSuccesfull == '1')
                .sort((a, b) => toTime(b.dateconfirm) - toTime(a.dateconfirm) || b.journalId - a.journalId)
        )
        setTimeout(() => setLoading(false), 1000);
    }

    function filterNotSuccesfull() {
        setLoading(true)
        setJournalList(datajournal.filter((item) => item.flowSuccesfull == 0))
        setTimeout(() => setLoading(false), 1000);
    }

    function allListData() {
        setLoading(true)
        setJournalList(datajournal)
        setTimeout(() => setLoading(false), 1000);
    }

    function filterWaitQARD() {
        setLoading(true)
        setJournalList(datajournal.filter((item) => item.QuarityStatus > 0))
        setTimeout(() => setLoading(false), 1000);
    }

    const sumapprove = datajournal.filter((item) => item.flowSuccesfull == '1');
    const sumpreapprove = datajournal.filter((item) => item.flowSuccesfull == 0);
    const sumQARD = datajournal.filter((item) => item.QuarityStatus > 0);

    const cardStyle = {
        cursor: 'pointer',
        backgroundColor: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.3)',
        borderRadius: 12,
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 140,
        transition: 'background 0.2s',
    };

    const iconBoxStyle = {
        backgroundColor: 'rgba(255,255,255,0.25)',
        borderRadius: 8,
        padding: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    return (
        <div style={{ backgroundColor: '#f4f6f8', minHeight: '100vh' }}>

            {/* Header */}
            <div style={{
                background: 'linear-gradient(135deg, #1a7f5a 0%, #28B463 100%)',
                padding: '16px 24px 20px',
                boxShadow: '0 3px 10px rgba(0,0,0,0.15)',
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                        <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
                            <FaTasks /> สถานะเอกสาร
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, marginTop: 3 }}>
                            เอกสารทั้งหมด {datajournal.length} รายการ
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        {/* Popup Search */}
                        <div style={{
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            border: '1px solid rgba(255,255,255,0.35)',
                            borderRadius: 8,
                            padding: '2px 4px',
                        }}>
                            <PopupSearch />
                        </div>

                        {/* Search Input */}
                        <div style={{ position: 'relative' }}>
                            <FaSearch style={{
                                position: 'absolute', left: 11, top: '50%',
                                transform: 'translateY(-50%)', color: '#aaa', fontSize: 13,
                            }} />
                            <input
                                type='text'
                                name='TextSearch'
                                placeholder='ค้นหาข้อมูล...'
                                onChange={(e) => heandleSearch(e)}
                                style={{
                                    paddingLeft: 34, paddingRight: 14, paddingTop: 8, paddingBottom: 8,
                                    borderRadius: 20, border: 'none', fontSize: 13,
                                    outline: 'none', width: 230,
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                    color: '#333',
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* Stat Cards */}
                <div style={{ display: 'flex', gap: 12, marginTop: 16, flexWrap: 'wrap' }}>
                    <div onClick={allListData} style={cardStyle}>
                        <div style={iconBoxStyle}><FaList size={16} color="#fff" /></div>
                        <div>
                            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>เอกสารทั้งหมด</div>
                            <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{datajournal.length}</div>
                        </div>
                    </div>

                    <div onClick={filterSuccesfull} style={cardStyle}>
                        <div style={iconBoxStyle}><FaCheck size={16} color="#fff" /></div>
                        <div>
                            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>อนุมัติแล้ว</div>
                            <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{sumapprove.length}</div>
                        </div>
                    </div>

                    <div onClick={filterNotSuccesfull} style={cardStyle}>
                        <div style={iconBoxStyle}><FaArchive size={16} color="#fff" /></div>
                        <div>
                            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>รออนุมัติ</div>
                            <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{sumpreapprove.length}</div>
                        </div>
                    </div>

                    <div onClick={filterWaitQARD} style={cardStyle}>
                        <div style={iconBoxStyle}><FaSearch size={16} color="#fff" /></div>
                        <div>
                            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>รอตรวจสอบ QA/RD</div>
                            <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{sumQARD.length}</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div>
                {loading ? (
                    <div style={{
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', justifyContent: 'center',
                        padding: 60, gap: 14,
                    }}>
                        <Spinner animation="grow" variant="success" style={{ width: 48, height: 48 }} />
                        <div style={{ color: '#6c757d', fontSize: 14 }}>กำลังโหลดข้อมูล...</div>
                    </div>
                ) : (
                    <Tablelistallprovebyuser datatable={journalList} />
                )}
            </div>
        </div>
    )
}

export default Journalstatusapprove
